// Ausweis color options
export const AUSWEIS_COLOR_OPTIONS = [
	"Grün",
	"Gelb",
	"Blau",
] as const;

export type AusweisColor = typeof AUSWEIS_COLOR_OPTIONS[number];